// removed by extract-text-webpack-plugin
module.exports = {"root":"ImageCarousel__root__UzQHJ","imageWrapper":"ImageCarousel__imageWrapper__1Bvgc","imageIndex":"ImageCarousel__imageIndex__1R0Vi","prev":"ImageCarousel__prev__1qaRJ","next":"ImageCarousel__next__PHTzr","loading":"ImageCarousel__loading__3NJba","loadingVisible":"ImageCarousel__loadingVisible__2MVw2","image":"ImageCarousel__image__2xo-B","imageLoading":"ImageCarousel__imageLoading__z4AI1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageCarousel/ImageCarousel.css
// module id = 1860
// module chunks = 0